import { render, staticRenderFns } from "./AdminWrapper.vue?vue&type=template&id=3990397c&scoped=true&"
import script from "./AdminWrapper.vue?vue&type=script&lang=js&"
export * from "./AdminWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AdminWrapper.vue?vue&type=style&index=0&id=3990397c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990397c",
  null
  
)

export default component.exports